import React from 'react';
import firebase from '../../firebase';
import { connect } from 'react-redux';
import { setCurrentChannel, setPrivateChannel, setExplorePage } from '../../actions';
import { Menu, Icon, Modal, Form, Label } from 'semantic-ui-react';
import channelIcon from '../Images/channelIcon.png';
import '../App.css';

class Channels extends React.Component {
    state = {
        activeChannel: '',
        user: this.props.currentUser,
        channel: null,
        channels: [],
        channelName: '',
        channelDetails: '',
        channelsRef: firebase.database().ref('channels'),
        messagesRef: firebase.database().ref('messages'),
        typingRef: firebase.database().ref('typing'),
        notifications: [],
        modal: false,
        firstLoad: true
    };

    componentDidMount() {
        this.addListeners();
    }

    componentWillUnmount() {
        this.removeListeners();
    }

    addListeners = () => {
        let loadedChannels = [];
        this.state.channelsRef.on('child_added', snap => {
            loadedChannels.push(snap.val());
            this.setState({ channels: loadedChannels }, () => this.setFirstChannel());
            this.addNotificationListener(snap.key);
        });
    };

    addNotificationListener = channelId => {
        this.state.messagesRef.child(channelId).on('value', snap => {
            if (this.state.channel) {
                this.handleNotifications(channelId, this.state.channel.id, this.state.notifications, snap);
            }
        });
    }

    handleNotifications = (channelId, currentChannelId, notifications, snap) => {
        let lastTotal = 0;

        let index = notifications.findIndex(notification => notification.id === channelId);

        if (index !== -1) {
            if (channelId !== currentChannelId) {
                lastTotal = notifications[index].total;

                if (snap.numChildren() - lastTotal > 0) {
                    notifications[index].count = snap.numChildren() - lastTotal;
                }
            }
            notifications[index].lastKnownTotal = snap.numChildren();
        } else {
            notifications.push({
                id: channelId,
                total: snap.numChildren(),
                lastKnownTotal: snap.numChildren(),
                count: 0
            })
        }
        this.setState({ notifications});

    }


    removeListeners = () => {
        this.state.channelsRef.off();
        this.state.channels.forEach(channel => {
            this.state.messagesRef.child(channel.id).off();
        })
    };

    setFirstChannel = () => {
        const firstChannel = this.state.channels[0];
        if (this.state.firstLoad && this.state.channels.length > 0) {
            this.props.setCurrentChannel(firstChannel);
        }
        this.setState({ firstLoad: false });
        this.setActiveChannel(firstChannel);
        this.setState({ channel: firstChannel });
    }

    addChannel = () => {
        const { channelsRef, channelName, channelDetails, user } = this.state;

        const key = channelsRef.push().key;

        const newChannel = {
            id: key,
            name: channelName,
            details: channelDetails,
            createdBy: {
                name: user.displayName,
                avatar: user.photoURL
            }
        };

        channelsRef
            .child(key)
            .update(newChannel)
            .then(() => {
                this.setState({ channelName: '', channelDetails: ''});
                this.closeModal();
                console.log('channel added');
            })
            .catch(err => {
                console.error(err);
            })
    }

    handleSubmit = event => {
        event.preventDefault();
        if(this.isFormValid(this.state)) {
            this.addChannel();
        }
    }

    isFormValid = ({ channelName, channelDetails }) => channelName && channelDetails;

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    changeChannel = channel => {
        this.setActiveChannel(channel);
        this.state.typingRef
            .child(this.state.channel.id)
            .child(this.state.user.uid)
            .remove();
        this.clearNotifications();
        this.props.setCurrentChannel(channel);
        this.props.setPrivateChannel(false);
        this.props.setExplorePage(false);
        this.setState({ channel });
    };

    clearNotifications = () => {
        let index = this.state.notifications.findIndex(notification => notification.id === this.state.channel.id);

        if (index !== -1) {
            let updatedNotifications = [...this.state.notifications];
            updatedNotifications[index].total = this.state.notifications[index].lastKnownTotal;
            updatedNotifications[index].count = 0;
            this.setState({ notifications: updatedNotifications});
        }
    }

    setActiveChannel = channel => {
        this.setState({ activeChannel: channel.id});
    };

    getNotificationCounts = channel => {
        let count = 0;

        this.state.notifications.forEach(notification => {
            if (notification.id === channel.id) {
                count = notification.count;
            }
        });

        if (count > 0) return count;
    }

    displayChannels = channels => 
        channels.length > 0 && channels.map(channel => (
            <div className="channelText">
            <Menu.Item
                key={channel.id}
                onClick={() => this.changeChannel(channel)}
                name={channel.name}
                active={channel.id === this.state.activeChannel}
            >
                {this.getNotificationCounts(channel) && (
                    <Label color ="red">{this.getNotificationCounts(channel)}</Label>
                )}

                <div
                style={{ display: 'flex', alignItems: 'center',
                        fontFamily: 'proxima-nova, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        fontSize: '14px',
                        marginTop: '3.75px'
                        }}>
                <div 
                className="channelCircleShape"
                style={{
                    width: '9px',
                    height: '9px',
                    backgroundColor: '#fff',
                    borderRadius: '50px',
                }} /> &nbsp;&nbsp;&nbsp;{channel.name}
                </div>
            </Menu.Item>
            </div>
        ));

    openModal = () => this.setState({ modal: true });

    closeModal = () => this.setState({ modal: false });

    render () {
        const { channels, modal } = this.state;

        return (
            <React.Fragment>
            <Menu.Menu className="channelMenuSections">
                <Menu.Item className="channelMenuItem" style={{color: '#fff', paddingBottom: '16px', marginLeft: '-10px'}}>
                    <span className="channelSpan" 
                        style={{ 
                        fontFamily: 'proxima-nova, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        color: '#fff',
                        justifyContent: 'space-between' }}>
                        <div>
                        <img src={channelIcon} alt="Icon" className="channelIcon" />&nbsp;&nbsp; PUBLIC CHANNELS ({ channels.length })
                        </div>
                        <Icon name="add" className="addIcon" onClick={this.openModal} />
                    </span>
                </Menu.Item>
                <div style={{ textTransform: 'lowercase' }}>
                {this.displayChannels(channels)}
                </div>
            </Menu.Menu>

            {/* Add Channel Modal */}
            <Modal basic open={modal} onClose={this.closeModal}>
                <Modal.Header>Add a Channel</Modal.Header>
                <Modal.Content>
                    <Form style={{ width: '1000px' }} onSubmit={this.handleSubmit}>
                        <Form.Field>
                            <p style={{
                                fontFamily: 'proxima-nova, sans-serif',
                                fontWeight: 400,
                                fontStyle: 'normal',
                                fontSize: '15px',
                                color: '#7a7a7a',
                            }}>This channel will be displayed publicly to all users.</p>
                            <label style={{
                                fontFamily: 'proxima-nova, sans-serif',
                                fontWeight: 400,
                                fontStyle: 'normal',
                                fontSize: '13.5px',
                                color: '#7a7a7a',
                            }}
                            className="modalLabel"
                            >
                            Name of Channel (20 characters or less)
                            </label>
                            <input
                                required
                                name="channelName"
                                maxLength="20"
                                onChange={this.handleChange}
                                style={{
                                    fontFamily: 'proxima-nova, sans-serif',
                                    fontWeight: 400,
                                    fontStyle: 'normal'
                                }}
                                className="modalInput"
                            />
                        </Form.Field>

                        <Form.Field style={{paddingTop: '10px'}}>
                            <label style={{
                                fontFamily: 'proxima-nova, sans-serif',
                                fontWeight: 400,
                                fontStyle: 'normal',
                                fontSize: '13.5px',
                                color: '#7a7a7a'
                            }}
                            className="modalLabel"
                            >
                            Channel Details (125 Characters or less)
                            </label>
                            <input
                                name="channelDetails"
                                maxLength="123"
                                onChange={this.handleChange}
                                style={{
                                    fontFamily: 'proxima-nova, sans-serif',
                                    fontWeight: 400,
                                    fontStyle: 'normal'
                                }}
                                className="modalInput"
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>

                <Modal.Actions>
                    <button className="addButton" style={{
                        fontFamily: 'proxima-nova, sans-serif',
                        fontWeight: 600,
                        fontStyle: 'normal'
                    }}
                    onClick={this.handleSubmit}>
                     {/*<Icon name="checkmark" />*/} Add   
                    </button>
                    <button 
                        className="cancelButton" 
                        style={{
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 600,
                            fontStyle: 'normal'
                        }}
                        onClick={this.closeModal}>
                     {/*<Icon name="remove" />*/} Cancel   
                    </button>
                </Modal.Actions>
            </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.currentUser
});

export default connect(mapStateToProps, { setCurrentChannel, setPrivateChannel, setExplorePage })(Channels);


// WEBPACK FOOTER //
// ./src/components/SidePanel/Channels.js